import { authApi, merchantApi } from "@api";
import { IConClose, SharedButton, SharedInput } from "@components";
import { enumNotiStatus, enumPdpaType, enumTypes, exchangedType } from "@configs";
import {
    IAddressData,
    IAmphur,
    IBenefit,
    ICoupon,
    IDisplay,
    IField,
    IFreePoint,
    IPdpa,
    IProvince,
    IReward,
    IRewardUsed,
    ISaveQuestion,
    ISubDistrict,
    ISurveyQuestions,
    ITerms,
} from "@interfaces";
import { selectAuth, selectMerchant, setFromLogin } from "@redux";
import { useNotify } from "@utils";
import { Col, Row, Select, Spin } from "antd";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import { FieldArray, Form, Formik } from "formik";
import Parser from "html-react-parser";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { formatDateFull } from "src/Utils/dateUtil";
import styled from "styled-components";
import CountdownTimer from "./shared/CountDownTimer";
import { Pending } from "./shared/Pending";
import { Points } from "./shared/Point";
import { Redeemed } from "./shared/Redeemed";
import { Used } from "./shared/Used";
const { Option } = Select;

interface IProps {
    handleCloseDetail: () => void;
    data: IBenefit | IReward | ICoupon | IFreePoint;
    handleConfirm?: () => void;
    handleCalculatePoint?: () => void;
    isConfirm?: boolean;
    isHistory?: boolean;
    isMerchantFreePoint?: boolean;
    quantity?: number;
    usedData?: IRewardUsed | undefined;
    cNote: string;
}

interface INoticProps {
    data: IPdpa;
    handleConfirm: (data: IPdpa, status: boolean) => void;
    isConfirm?: boolean;
}
interface ITermsProps {
    data: ITerms | null;
    handleConfirm: () => void;
    isConfirm?: boolean;
    showTerm?: boolean;
    termsTitle?: string;
}
interface IQuestionProps {
    data: IField[];
    handlDone: () => void;
    isHasQuestion?: boolean;
}

export const ComponentPopUpConfirm = (props: IProps) => {
    //page hooks
    const { t } = useTranslation();
    // const dispatch = useDispatch();

    //redux states
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { userInfo } = useSelector(selectAuth);

    //page redux
    const {
        handleCloseDetail,
        data,
        handleConfirm,
        handleCalculatePoint,
        isConfirm = true,
        quantity,
        isMerchantFreePoint,
        cNote,
    } = props;
    //page variable

    const handleConfirmPopup = () => {
        if (handleConfirm) {
            // dispatch(resetConfirm());
            handleConfirm();
            handleCloseDetail();
        }
    };

    const setNamePopup = () => {
        const isPoint =
            //@ts-ignore
            handleCalculatePoint && handleCalculatePoint()
                ? ", " + handleCalculatePoint() + " points"
                : "";

        switch (data.type) {
            case enumTypes.REWARD: {
                const name = " (" + data.name + " x " + quantity + isPoint + ")";
                return `${t("page.redemption_reward")}  ${name}`;
            }
            case enumTypes.BENEFIT: {
                const name = " (" + data.name + " x " + 1 + ")";
                return `${t("page.redemption")}  ${name}`;
            }
            case enumTypes.COUPON: {
                //@ts-ignore
                const unit =
                    ", " +
                    //@ts-ignore
                    data.benefit +
                    //@ts-ignore
                    (data.unit === "BAHT" ? t("page.BAHT") : t("page.percent_sign"));
                const name = " (" + data.name + " x " + 1 + unit + ")";
                return `${t("page.redemption")}  ${name}`;
            }
            case enumTypes.FREE_POINT: {
                const name =
                    " (" +
                    data.name +
                    " x " +
                    1 +
                    ", " +
                    data.point +
                    " " +
                    t("page._points") +
                    ")";
                return `${t("page.collection")} ${name}`;
            }
        }
    };
    const getTypeText = () => {
        if (data?.type === undefined) return "-";
        switch (data.type) {
            case enumTypes.REWARD:
                return t("page.reward");
                break;
            case enumTypes.COUPON:
                return t("page.coupon");
                break;
            case enumTypes.BENEFIT:
                return t("page.reward");
                break;
            case enumTypes.FREE_POINT:
                return t("page.point");
                break;
            default:
                return "-";
                break;
        }
    };
    //page variable
    const dateFormat = () => {
        if (isMerchantFreePoint) {
            //@ts-ignore
            return dayjs(data?.updatedAt).format("DD/MM/YYYY h:mm:ss a");
        } else {
            return dayjs().format("DD/MM/YYYY h:mm:ss a");
        }
    };

    return (
        <StyledPopupRedeem isConfirm={isConfirm}>
            <div className="box-popupconfirm">
                <div className="img-popupconfirm">
                    <img src={merchant?.themes?.basicThemeSetting?.iconGeneral[0]?.image} alt="" />
                </div>
                <div className="title">
                    <div className="text-sub-header">{t("page.pleaseconfirm")}</div>
                </div>
                <div className="btn-popupconfirm">
                    <StyledUsedBtn
                        className="btn-cancel"
                        themeColor={themes?.themeColor!}
                        onClick={handleCloseDetail}
                    >
                        Cancel
                    </StyledUsedBtn>
                    <StyledUsedBtn
                        className="btn-redeem"
                        themeColor={themes?.themeColor!}
                        type="submit"
                        onClick={handleConfirmPopup}
                    >
                        Confirm
                    </StyledUsedBtn>
                </div>
            </div>
            {/* <StyledContainerHistoryDetail isConfirm={isConfirm}>
            <div className="content">
                <div className="close" onClick={handleCloseDetail}>
                    <IConClose width={16} />
                </div>
                {isConfirm && (
                    <div className="confirmation text-sub-header">{t("page.confirmation")}</div>
                )}
                <div className="title text-normal-bold">{t("page.name")}</div>
                <div className="desc text-sec-sub-header">{userInfo?.fullName}</div>
                <div className="title text-normal-bold">{t("page.date_time")}:</div>
                <div className="desc text-sec-sub-header eng">{dateFormat()}</div>
                <div className="title text-normal-bold">{t("page.type")}</div>
                <div className="desc text-sec-sub-header">{getTypeText()}</div>
                <div className="title text-normal-bold">{t("page.transaction")}</div>
                <div className="desc text-sec-sub-header">{setNamePopup()}</div>
                {cNote !== "" &&
                    <>
                        <div className="title text-normal-bold">{t("page.note")}</div>
                        <div className="desc text-sec-sub-header">{cNote}</div>
                    </>
                }
                {data?.alienCode && (
                    <StyledAlienCode mainColor={themes?.themeColor!}>
                        <div className="title text-normal-bold">{t("page.redemption_code")}</div>
                        <div className="alien-code-btn">{data?.alienCode}</div>
                    </StyledAlienCode>
                )}
                {isConfirm && (
                    <>
                        <div className="btnLayout confirm-btn-layout">
                            <StyledButton
                                size="large"
                                bg_color={themes?.themeColor!}
                                type="submit"
                                className="confirm-btn btn-text"
                                onClick={handleConfirmPopup}
                            >
                                {t("page.confirm")}
                            </StyledButton>
                        </div>
                    </>
                )}
            </div>
        </StyledContainerHistoryDetail> */}
        </StyledPopupRedeem>
    );
};

interface IDoneProps {
    handleCloseDetail: () => void;
    data: any;
    handleConfirm?: () => void;
    handleCalculatePoint?: () => void;
    isConfirm?: boolean;
    isHistory?: boolean;
    isMerchantFreePoint?: boolean;
    quantity?: number;
    usedData?: IRewardUsed | undefined;
    cNote?: any;
}

const initDataDont = {
    updatedAtHistory: "",
    levelIds: [],
    name: "",
    imageUrl: [""],
    description: "",
    startDate: "",
    endDate: "",
    birthMonths: [""],
    point: 0,
    quantityPoint: 0,
    ticketCode: "",
};

export const ComponentPopUpDone = (props: IDoneProps) => {
    //page hooks
    const { t } = useTranslation();

    const INIT_ADDRESS: IAddressData = {
        address: "",
        district: "",
        province: "",
        subDistrict: "",
        postCode: "",
    };

    //redux states
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { userInfo } = useSelector(selectAuth);
    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictIndex, setSubDistrictIndex] = useState<number>(0);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    //page redux
    const {
        handleCloseDetail,
        data = initDataDont,
        isHistory,
        handleCalculatePoint,
        usedData,
        isConfirm = true,
        isMerchantFreePoint,
    } = props;
    //page variable

    const today = new Date();
    const [showpage1, setShowPage1] = useState(false);
    const [showpage2, setShowPage2] = useState(false);
    const [showpage3, setShowPage3] = useState(false);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(true);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [display, setDisplay] = useState<IDisplay>({
        province: "",
        district: "",
        subDistrict: "",
    });
    const handleChange = (value: string) => {
        //
    };

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
        return allRes;
    };

    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);

        return allAmphur;
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        setSubDistrictIndex(
            subRes.data.result.findIndex(
                (item: any) => item?.district_id === userInfo?.contact?.address?.subDistrict
            )
        );
        let newAdd = addressData;
        newAdd.province = subRes.data.result[0]?.province_id || "";
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
        return subRes;
    };

    const openAddress = () => {
        console.log("start");
        let provinceListNew = provinceList;
        if (provinceListNew === undefined || provinceListNew === null) {
            provinceListNew = [];
        }
        let amphurListNew = amphurList;
        if (amphurListNew === undefined || amphurListNew === null) {
            amphurListNew = [];
        }
        let subDistrictListNew = subDistrictList;
        if (subDistrictListNew === undefined || subDistrictListNew === null) {
            subDistrictListNew = [];
        }
        let proObj = provinceListNew.find((item) => item?.province_id === addressData.province);
        let disObj = amphurListNew.find((item) => item?.amphur_id === addressData.district);
        let subObj = subDistrictListNew[parseInt(addressData?.subDistrict)];

        if (proObj !== undefined && disObj !== undefined && subObj !== undefined) {
            setDisplay({
                province: proObj?.province_name_tha || "",
                district: disObj?.amphur_name_tha || "",
                subDistrict: subObj?.district_name_tha || "",
            });
        }
        console.log("end address", provinceListNew);
    };

    const getMainAddress = async () => {
        if (userInfo) {
            const provinces: any = await getAllProvince();
            const amphurs: any = await getAmphur(parseInt(userInfo?.contact?.address?.province!));
            const subDistricts: any = await getSubDistrictByamphur(
                parseInt(userInfo?.contact?.address?.district!)
            );

            const firstFetchAddress = () => {
                openAddress();
                if (userInfo?.contact?.address) {
                    let proObj = provinces.data.result.find(
                        (item: any) => item?.province_id === addressData.province
                    );
                    let disObj = amphurs.data.result.find(
                        (item: any) => item?.amphur_id === addressData.district
                    );
                    let subObj = subDistricts[parseInt(addressData?.subDistrict)];
                    setDisplay({
                        province: proObj?.province_name_tha || "",
                        district: disObj?.amphur_name_tha || "",
                        subDistrict: subObj?.district_name_tha || "",
                    });
                    let payload: IAddressData = {
                        address: userInfo?.contact?.address?.address,
                        province: userInfo?.contact?.address?.province,
                        district: userInfo?.contact?.address?.district,
                        // subDistrict: userInfo?.contact?.address?.subDistrict,
                        subDistrict: subDistrictIndex !== -1 ? subDistrictIndex.toString() : "",
                        postCode: userInfo?.contact?.address?.postCode,
                    };
                    setAddressData(payload);
                }
            };
            firstFetchAddress();
        }
    };

    useEffect(() => {
        getMainAddress();
    }, [userInfo]);

    const dateFormat = () => {
        if (isMerchantFreePoint) {
            //@ts-ignore
            return dayjs(data?.updatedAt).format("DD/MM/YYYY h:mm:ss a");
        } else {
            if (isHistory) {
                const date = dayjs(new Date(data.updatedAtHistory)).format("DD/MM/YYYY h:mm:ss a");
                return date;
            } else return dayjs().format("DD/MM/YYYY h:mm:ss a");
        }
    };

    const setNamePopup = () => {
        if (isHistory) {
            if (isMerchantFreePoint) {
                return data?.exchangedType === exchangedType.RECEIVED
                    ? t("page.add_points_from_shop", { points: data.quantity })
                    : t("page.sub_points_from_shop", { points: data.quantity });
            } else {
                switch (data.type) {
                    case enumTypes.REWARD: {
                        if (data.exchangedType && data.exchangedType === exchangedType.RECEIVED) {
                            return t("page.used") + " " + data.point + " " + t("page._points");
                        } else {
                            // const isPoint =
                            //     //@ts-ignore
                            //     handleCalculatePoint && handleCalculatePoint()
                            //         ? ", " + handleCalculatePoint() + " " + t("page._items")
                            //         : "";
                            //@ts-ignore
                            const count = data.count || data.quantityPoint;
                            const name =
                                " (" +
                                data.name +
                                " x " +
                                count +
                                ", " +
                                data?.point +
                                " " +
                                t("page._points") +
                                ")";
                            return t("page.redemption") + name;
                        }
                    }
                    case enumTypes.BENEFIT: {
                        const name = " (" + data.name + " x " + 1 + ")";
                        return t("page.redemption") + name;
                    }
                    case enumTypes.COUPON: {
                        if (data.exchangedType === exchangedType.RECEIVED) {
                            const name = " (" + data.name + " x " + 1 + ")";
                            return t("page.collection") + name;
                        } else {
                            const name = " (" + data.name + " x " + 1 + ")";
                            return t("page.redemption") + name;
                        }
                    }
                    case enumTypes.FREE_POINT: {
                        return (
                            t("page.collection") +
                            " " +
                            "( " +
                            t("page.free_point") +
                            " + " +
                            data?.point +
                            " " +
                            t("page._points") +
                            ")"
                        );
                    }
                }
            }
        } else {
            switch (data.type) {
                case enumTypes.REWARD: {
                    if (data.exchangedType && data.exchangedType === exchangedType.RECEIVED) {
                        return t("page.used") + " " + data.point + " " + t("page._points");
                    } else {
                        const isPoint =
                            //@ts-ignore
                            handleCalculatePoint && handleCalculatePoint()
                                ? ", " + handleCalculatePoint() + " " + t("page._points")
                                : "";
                        //@ts-ignore
                        const count = data.count || data.quantityPoint;
                        const name = " (" + data.name + " x " + count + isPoint + ")";
                        return t("page.redemption") + name;
                    }
                }
                case enumTypes.BENEFIT: {
                    const name = " (" + data.name + " x " + 1 + ")";
                    return t("page.redemption") + name;
                }
                case enumTypes.COUPON: {
                    const name = " (" + data.name + " x " + 1 + ")";
                    return t("page.redemption") + name;
                }
                case enumTypes.FREE_POINT: {
                    return "x";
                }
            }
        }
    };
    const getTypeText = () => {
        if (data?.type === undefined) return "-";
        switch (data.type) {
            case enumTypes.REWARD:
                return t("page.reward");
                break;
            case enumTypes.COUPON:
                return t("page.coupon");
                break;
            case enumTypes.BENEFIT:
                return t("page.reward");
                break;
            case enumTypes.FREE_POINT:
                return t("page.point");
                break;
            default:
                return "-";
                break;
        }
    };
    const getStatusText = (status: enumNotiStatus) => {
        switch (status) {
            case enumNotiStatus.PENDING:
                return "Pending";
                break;
            case enumNotiStatus.RESOLVED:
                return "Used";
                break;
            case enumNotiStatus.REJECT:
                return "Cancel";
                break;
            default:
                return "Pending";
                break;
        }
    };

    const isExpired = (expireDate: string | undefined): boolean => {
        if (!expireDate) return false; // ถ้าไม่มีวันที่หมดอายุ ให้คืนค่า false
        const today = dayjs(); // ใช้ dayjs เพื่อรับวันที่ปัจจุบัน
        return dayjs(expireDate).isBefore(today); // เปรียบเทียบวันที่หมดอายุ
    };

    const expired = isExpired(data.expireDate);

    return (
        <StyledContainerHistoryDetailDone isConfirm={isConfirm}>
            <div className="page-wrapper">
                {showpage3 ? (
                    <div className="topic-popup-product">
                        <div className="confirmation text-sub-header">Confirm delivery address</div>
                    </div>
                ) : null}
                {showpage2 ? (
                    <div className="topic-popup-product">
                        <div className="confirmation text-sub-header">Delivery address</div>
                    </div>
                ) : null}
                <div className="close" onClick={handleCloseDetail}>
                    <IConClose width={16} />
                </div>
                {showpopuppage ? (
                    <div className="content-layout">
                        <div className="content">
                            {showpage1 ? (
                                <>
                                    <div className="header-product">
                                        <div className="layout-img">
                                            <div className="img-product">
                                                <img src={data?.imageUrl?.[0]} />
                                            </div>
                                        </div>
                                        <div className="topic-product">{data.name}</div>
                                        <div className="total-point-product">Total 300 Rewards</div>
                                    </div>
                                    <div className="content-product">
                                        <div className="topic-detail">Conditions</div>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: data?.description }}
                                        ></div>
                                    </div>
                                    <StyledUsedBtn
                                        className="btn-redeem"
                                        themeColor={themes?.themeColor!}
                                        onClick={() => {
                                            setShowPage1(false);
                                            setShowPage2(true);
                                        }}
                                    >
                                        Redeem
                                    </StyledUsedBtn>
                                </>
                            ) : null}
                            {showpage2 ? (
                                <>
                                    <div className="content-product">
                                        <div className="form-content-product">
                                            <div className="title">Province*</div>
                                            <Select defaultValue="Select Province" />
                                        </div>
                                        <Row gutter={[16, 16]}>
                                            <Col span={12}>
                                                <div className="form-content-product">
                                                    <div className="title">District*</div>
                                                    <Select defaultValue="Select District" />
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form-content-product">
                                                    <div className="title">Sub-District*</div>
                                                    <Select defaultValue="Select Sub-District" />
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="form-content-product">
                                            <div className="title">Zipcode*</div>
                                            <SharedInput
                                                placeholder="Select Zipcode"
                                                styleParent={{ height: "48px" }}
                                                style={{
                                                    backgroundColor: "white",
                                                    border: "1px solid gray",
                                                }}
                                            />
                                        </div>
                                        <div className="form-content-product">
                                            <div className="title">Address*</div>
                                            <SharedInput
                                                placeholder="Select Address"
                                                styleParent={{ height: "48px" }}
                                                style={{
                                                    backgroundColor: "white",
                                                    border: "1px solid gray",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <StyledUsedBtn
                                        className="btn-redeem"
                                        themeColor={themes?.themeColor!}
                                        onClick={() => {
                                            setShowPage2(false);
                                            setShowPage3(true);
                                        }}
                                    >
                                        Redeem
                                    </StyledUsedBtn>
                                </>
                            ) : null}
                            {showpage3 ? (
                                <>
                                    <div className="content-product">
                                        <div className="form-content-product">
                                            <TextArea rows={4} />
                                        </div>
                                    </div>
                                    <StyledUsedBtn
                                        className="btn-redeem"
                                        themeColor={themes?.themeColor!}
                                        onClick={() => {
                                            setShowPage3(false);
                                            setShowPage4(true);
                                            setShowPopupPage(false);
                                        }}
                                    >
                                        Redeem
                                    </StyledUsedBtn>
                                </>
                            ) : null}

                            {showresult ? (
                                <>
                                    <div className="set-result">
                                        <div className="layout-img">
                                            <div className="img-product">
                                                <img src={data ? data.imageUrl?.[0] : ""} />
                                            </div>
                                        </div>
                                        <div className="fixed-layout">
                                            <div className="content-info">
                                                <div className="header-product">
                                                    <div className="topic-product">{data.name}</div>
                                                    {/* <div className="total-point-product">100 left</div> */}
                                                    {data.points ? (
                                                        <>
                                                            <div className="point-product">
                                                                <span>
                                                                    <Points size={16} />
                                                                </span>
                                                                {data.points}
                                                            </div>
                                                        </>
                                                    ) : null}
                                                    <div className="expier-product">
                                                        {t("page.exp")} :{" "}
                                                        {formatDateFull(data.startDate)} -{" "}
                                                        {formatDateFull(data.endDate)}
                                                    </div>
                                                    {data.variants?.length > 0 && (
                                                        <div
                                                            className="expier-product"
                                                            style={{ marginTop: 10 }}
                                                        >
                                                            {t("page.select_type")} :{" "}
                                                            {data?.variants?.[0] || "-"}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {data?.autoUseTime?.enabled && (
                                                <div className="countdownBox">
                                                    <CountdownTimer
                                                        targetDate={data?.autoUseTimeOut}
                                                    />
                                                    <div style={{ textAlign: "center" }}>
                                                        The code will expire{" "}
                                                        {data?.autoUseTime?.time}{" "}
                                                        {data?.autoUseTime?.timeUnit === "s"
                                                            ? "seconds "
                                                            : data?.autoUseTime?.timeUnit === "m"
                                                            ? "minutes "
                                                            : data?.autoUseTime?.timeUnit === "h"
                                                            ? "hours "
                                                            : " "}
                                                        after clicking the confirm button.
                                                    </div>
                                                </div>
                                            )}
                                            <div className="action-layout">
                                                {data?.isDelivery ? null : (
                                                    <div className="qr-layout">
                                                        <div className="qr-box">
                                                            <QRCode
                                                                value={
                                                                    data?.alienCode
                                                                        ? data?.alienCode
                                                                        : data?.ticketCode || ""
                                                                }
                                                                size={150}
                                                            />
                                                        </div>
                                                        <StyledCodeButton
                                                            mainColor={themes?.themeColor!}
                                                        >
                                                            {data?.alienCode
                                                                ? data?.alienCode
                                                                : data?.ticketCode || "---"}
                                                        </StyledCodeButton>
                                                    </div>
                                                )}

                                                {data?.alienCode && (
                                                    <StyledAlienCode
                                                        mainColor={themes?.themeColor!}
                                                    >
                                                        <div className="title text-normal-bold">
                                                            {data?.type === enumTypes.COUPON
                                                                ? t("page.couponcode")
                                                                : data?.type === enumTypes.BENEFIT
                                                                ? t("page.benefitCode")
                                                                : t("page.rewardCode")}
                                                        </div>
                                                        <div className="alien-code-btn">
                                                            {data?.alienCode}
                                                        </div>
                                                        <div className="custom-barcode">
                                                            <Barcode value={data?.alienCode} />
                                                        </div>
                                                    </StyledAlienCode>
                                                )}
                                                {data.notiStatus === "REDEEMED" && !expired ? (
                                                    <p className="redeemed-product">
                                                        <span className="redeemed">
                                                            <Redeemed color="#336C51" />
                                                        </span>
                                                        {t("page.history_redeem.RESOLVED")}
                                                    </p>
                                                ) : expired ? (
                                                    <p className="pending-product">
                                                        <span className="pending">
                                                            <Pending color="#ED773A" />
                                                        </span>
                                                        Expired
                                                    </p>
                                                ) : null}
                                                {data.notiStatus === "PENDING" && !expired ? (
                                                    <p className="pending-product">
                                                        <span className="pending">
                                                            <Pending color="#ED773A" />
                                                        </span>
                                                        Redeemed
                                                    </p>
                                                ) : expired ? (
                                                    <p className="pending-product">
                                                        <span className="pending">
                                                            <Pending color="#ED773A" />
                                                        </span>
                                                        Expired
                                                    </p>
                                                ) : null}
                                                {data.notiStatus === "USED" ||
                                                (data.notiStatus === "RESOLVED" && !expired) ? (
                                                    <p className="used-product">
                                                        <span className="used">
                                                            <Used color="#336C51" />
                                                        </span>
                                                        {t("page.history_redeem.use")}
                                                    </p>
                                                ) : expired ? (
                                                    <p className="pending-product">
                                                        <span className="pending">
                                                            <Pending color="#ED773A" />
                                                        </span>
                                                        Expired
                                                    </p>
                                                ) : null}
                                                {data?.isDelivery ? (
                                                    <div className="result-delivery">
                                                        <div className="title-delivery">
                                                            {t("page.youDelivery")}
                                                        </div>
                                                        <div className="box-delivery">
                                                            <span>
                                                                <img src="../../images/pin-address.svg" />
                                                                Address
                                                            </span>
                                                            {/* <p>
                                                                {addressData?.address} &nbsp;
                                                                {display?.province} &nbsp;
                                                                {display.district} &nbsp;
                                                                {display.subDistrict} &nbsp;
                                                                {addressData?.postCode}
                                                            </p> */}
                                                            <p>{data?.shippingAddress}</p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p className="note">
                                                        <br />
                                                        {data?.noticeText
                                                            ? data?.noticeText
                                                            : t("page.desConfirm")}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                ) : null}
                {showpage4 ? (
                    <StyledPopupRedeem isConfirm={isConfirm}>
                        <div className="box-popupconfirm">
                            <div className="img-popupconfirm">
                                <img
                                    src={merchant?.themes?.basicThemeSetting?.iconGeneral[0]?.image}
                                    alt=""
                                />
                            </div>
                            <div className="title">
                                <div className="text-sub-header">{t("page.pleaseconfirm")}</div>
                            </div>
                            <div className="btn-popupconfirm">
                                <StyledUsedBtn
                                    className="btn-cancel"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => {
                                        setShowPage4(false);
                                        setShowPage3(true);
                                        setShowPopupPage(true);
                                    }}
                                >
                                    Cancel
                                </StyledUsedBtn>
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => {
                                        setShowPage4(false);
                                        setShowResult(true);
                                        setShowPopupPage(true);
                                    }}
                                >
                                    Confirm
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </StyledPopupRedeem>
                ) : null}
            </div>
        </StyledContainerHistoryDetailDone>
    );
};
export const ComponentPopUpNotic = (props: INoticProps) => {
    //page hooks
    const { t } = useTranslation();
    // const dispatch = useDispatch();

    //redux states
    const { themes } = useSelector(selectMerchant);
    //page redux
    const { data, handleConfirm, isConfirm = true } = props;
    const [isDisable, setIsDisable] = useState<boolean>(true);
    useEffect(() => {
        if (data) {
            const scrollableContent = document.getElementById("scroll-part");
            if (scrollableContent) {
                setIsDisable(scrollableContent.scrollHeight > scrollableContent.clientHeight);
            }
        }
    }, [data]);

    const handleScroll = (e: any) => {
        // let isBottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        let isBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 50;
        if (isBottom) {
            setIsDisable(false);
        }
    };

    const onConfirm = (condition: boolean) => {
        //
        setIsDisable(true);
        handleConfirm(data, condition);
    };

    return (
        <StyledContainerHistoryDetail themeColor={themes?.themeColor!} isConfirm={isConfirm}>
            <div className="content">
                <div className="pdpa-name text-sub-header">{data.nameForm}</div>
                {/* <div className="close" onClick={handleCloseDetail}>
                    <IConClose width={16} />
                </div> */}
                <div className="pdpa-sub-title">(Consent form v.1)</div>
                <div className="pdpa-content-layout">
                    <div className="pdpa-container">
                        <div className="scroll-layout" id="scroll-part" onScroll={handleScroll}>
                            {Parser(data.detail)}
                        </div>
                    </div>
                </div>
                <div className="pdpa-condition">
                    ฉันยินยอมให้ร้านค้าและบริษัทใช้ข้อมูลส่วนตัวของฉันตามนโยบายความเป็นส่วนตัว
                </div>
                <div className="btnLayout confirm-btn-layout">
                    {data.pdpaType === enumPdpaType.NOTICE ? (
                        <>
                            <StyledButtonDecline
                                size="large"
                                bg_color={"#fff"}
                                style={{ border: "1px solid #e1e1e1", width: "35%" }}
                                type="submit"
                                className="confirm-btn btn-text decline-btn"
                                onClick={() => onConfirm(false)}
                                disabled={isDisable}
                            >
                                {t("page.decline")}
                            </StyledButtonDecline>
                            <StyledButton
                                size="large"
                                bg_color={themes?.themeColor!}
                                type="submit"
                                className="confirm-btn btn-text"
                                onClick={() => onConfirm(true)}
                                disabled={isDisable}
                            >
                                {t("page.accept")}
                            </StyledButton>
                        </>
                    ) : (
                        <>
                            {/* <StyledButton
                                size="large"
                                bg_color={"#fff"}
                                style={{ color: "#000", border: "1px solid #e1e1e1", width: "35%" }}
                                type="submit"
                                className="confirm-btn btn-text decline-btn"
                                onClick={() => handleConfirm(data, false)}
                            >
                                {t("page.decline")}
                            </StyledButton> */}
                            <StyledButtonDecline
                                size="large"
                                bg_color={"#fff"}
                                style={{ border: "1px solid #e1e1e1", width: "35%" }}
                                type="submit"
                                className="confirm-btn btn-text decline-btn"
                                onClick={() => onConfirm(false)}
                                disabled={isDisable}
                            >
                                {t("page.decline")}
                            </StyledButtonDecline>
                            <StyledButton
                                size="large"
                                bg_color={themes?.themeColor!}
                                style={{ width: "35%" }}
                                type="submit"
                                className="confirm-btn btn-text"
                                onClick={() => onConfirm(true)}
                                disabled={isDisable}
                            >
                                {t("page.accept")}
                            </StyledButton>
                        </>
                    )}
                </div>
            </div>
        </StyledContainerHistoryDetail>
    );
};
export const ComponentPopUpTerms = (props: ITermsProps) => {
    //page hooks
    const { t } = useTranslation();
    // const dispatch = useDispatch();

    //redux states
    const { themes } = useSelector(selectMerchant);
    //page redux
    const { data, handleConfirm, isConfirm = true, showTerm, termsTitle } = props;
    const [isDisable, setIsDisable] = useState<boolean>(true);
    useEffect(() => {
        const scrollableContent = document.getElementById("scroll-part");
        if (scrollableContent) {
            setIsDisable(scrollableContent.scrollHeight > scrollableContent.clientHeight);
        }
    }, []);
    const handleScroll = (e: any) => {
        // let isBottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        let isBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 50;
        if (isBottom) {
            setIsDisable(false);
        }
    };
    return (
        <StyledContainerHistoryDetail isConfirm={isConfirm} themeColor={themes?.themeColor!}>
            <div className="content">
                <div className="pdpa-name text-sub-header">
                    {/* {t(`${termsTitle}`) || t("page.terms_conditons")} */}
                    {t("page.terms_conditons")}
                </div>
                <div className="pdpa-content-layout">
                    <div className="pdpa-container">
                        <div className="scroll-layout" id="scroll-part" onScroll={handleScroll}>
                            {Parser(data?.TermCondition || "")}
                        </div>
                    </div>
                </div>
                <div className="btnLayout confirm-btn-layout">
                    <StyledButton
                        size="large"
                        bg_color={themes?.themeColor!}
                        type="submit"
                        className="confirm-btn btn-text"
                        onClick={handleConfirm}
                        disabled={isDisable}
                    >
                        {t("page.accept")}
                    </StyledButton>
                </div>
            </div>
        </StyledContainerHistoryDetail>
    );
};
interface IQuestionForm {
    questionsObj: ISaveQuestion[];
}
export const ComponentUnfilledQuestions = (props: IQuestionProps) => {
    //page hooks
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [spinning, setSpinning] = useState(true);
    const [questions, setQuestions] = useState<ISaveQuestion[]>([]);
    //redux states
    const { themes } = useSelector(selectMerchant);
    const { success, error, warning } = useNotify();
    const { data, handlDone, isHasQuestion = true } = props;

    useEffect(() => {
        formatQuestion();
    }, [data]);

    const formatQuestion = async () => {
        setSpinning(true);
        const res = await data.reduce<ISaveQuestion[]>((a, c) => {
            a.push({
                questionId: c._id || "",
                freeTextAnswer: "",
                answers: [],
                isFreeTextAnswer: c.isFreeTextAnswer,
                questionName: c.fieldName,
                options: c.options,
                multiple: c.multiple,
                isRequired: c.isRequired,
                propertyName: c.propertyName,
            });
            return a;
        }, []);
        setQuestions(res);
        setSpinning(false);
    };

    const handleSubmit = async (values: IQuestionForm) => {
        try {
            let arr: ISurveyQuestions[] = [];
            let checkEmp = false;
            values.questionsObj.forEach((fItem, fIndex) => {
                let outAns: any = fItem.answers;
                let outText: any = "";
                if (fItem?.isFreeTextAnswer) {
                    outAns = [];
                    outText = fItem.freeTextAnswer;
                } else if (!fItem?.multiple) {
                    outAns = [];
                    outText = fItem.answers;
                }
                if (fItem?.isRequired) {
                    if (outText === "") {
                        if (outAns.length === 0) {
                            checkEmp = true;
                        }
                    }
                }
                let outObj: ISurveyQuestions = {
                    questionId: fItem.questionId,
                    question: fItem.questionName,
                    answers: outAns,
                    propertyName: fItem.propertyName,
                    freeTextAnswer: outText,
                    isRequired: fItem.isRequired,
                };
                arr.push(outObj);
            });
            if (checkEmp) {
                warning(t("message.question.required"));
            } else {
                let updateRes = await authApi.updateAnswer({
                    surveyQuestions: arr,
                });
                success(t("message.update.success"));

                dispatch(setFromLogin(false));

                // const res = await authApi.saveQuestionIsRequire([...values.questionsObj]);
                // if (res.data.error === "0") {
                //     success(res.data.msg);
                // } else {
                //     error(res.data.msg);
                // }
                handlDone();
            }
        } catch (err: any) {
            error(t("message.update.fail"));
            handlDone();
        }
        // finally {
        //     handlDone();
        // }
    };
    const init = {
        questionsObj: questions,
    };

    return (
        <StyledContainerHistoryDetail isConfirm={isHasQuestion} themeColor={themes?.themeColor!}>
            <div className="content">
                <div className="question-title text-sub-header">
                    {t("page.additional_information_questionnaire")}
                </div>
                <div className="question-sub-title text-sub-header">
                    {t("page.please_enter_the_details_above")}
                </div>
                <div className="pdpa-content-layout">
                    {spinning ? (
                        <Spin />
                    ) : (
                        <div className="question-container">
                            <Formik initialValues={init} onSubmit={handleSubmit}>
                                {({ values, handleChange, setFieldValue }) => (
                                    <Form>
                                        <FieldArray name="questionsObj">
                                            {() => (
                                                <div>
                                                    {values.questionsObj.length > 0 &&
                                                        values.questionsObj.map(
                                                            (question, index) => (
                                                                <div key={index}>
                                                                    {question.isFreeTextAnswer ? (
                                                                        <SharedInput
                                                                            placeholder={
                                                                                `${question?.questionName}` +
                                                                                `${
                                                                                    values
                                                                                        .questionsObj[
                                                                                        index
                                                                                    ].isRequired
                                                                                        ? " *"
                                                                                        : ""
                                                                                }`
                                                                            }
                                                                            name={`questionsObj[${index}].freeTextAnswer`}
                                                                            value={
                                                                                values.questionsObj[
                                                                                    index
                                                                                ].freeTextAnswer
                                                                            }
                                                                            onChange={handleChange}
                                                                        />
                                                                    ) : (
                                                                        <StyledSelect>
                                                                            <Select
                                                                                placeholder={
                                                                                    `${question?.questionName}` +
                                                                                    `${
                                                                                        values
                                                                                            .questionsObj[
                                                                                            index
                                                                                        ].isRequired
                                                                                            ? " *"
                                                                                            : ""
                                                                                    }`
                                                                                }
                                                                                value={
                                                                                    question.answers
                                                                                }
                                                                                onChange={(
                                                                                    value: string[]
                                                                                ) =>
                                                                                    setFieldValue(
                                                                                        `questionsObj[${index}].answers`,
                                                                                        value
                                                                                    )
                                                                                }
                                                                                key={index}
                                                                                mode={
                                                                                    question.multiple
                                                                                        ? "multiple"
                                                                                        : undefined
                                                                                }
                                                                                showArrow={true}
                                                                            >
                                                                                {question.options.map(
                                                                                    (
                                                                                        option,
                                                                                        index
                                                                                    ) => {
                                                                                        return (
                                                                                            <Option
                                                                                                key={
                                                                                                    index
                                                                                                }
                                                                                                value={
                                                                                                    option.optionName
                                                                                                }
                                                                                            >
                                                                                                {
                                                                                                    option.optionName
                                                                                                }
                                                                                            </Option>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </Select>
                                                                        </StyledSelect>
                                                                    )}
                                                                </div>
                                                            )
                                                        )}
                                                    <div className="btnLayout confirm-btn-layout">
                                                        <StyledButton
                                                            size="large"
                                                            bg_color={themes?.themeColor!}
                                                            type="submit"
                                                            className="confirm-btn btn-text"
                                                        >
                                                            {t("page.accept")}
                                                        </StyledButton>
                                                    </div>
                                                </div>
                                            )}
                                        </FieldArray>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    )}
                </div>
            </div>
        </StyledContainerHistoryDetail>
    );
};
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledSelect = styled.div`
    margin-bottom: 16px;
    .ant-select {
        height: 48px;
        .ant-select-selection {
            height: 100%;
            .ant-select-selection__rendered {
                height: 100%;
            }
        }
    }
    .ant-select-selection--multiple {
        .ant-select-arrow {
            margin-top: 0px;
        }
    }
`;
const StyledCodeButton = styled.div<{ mainColor?: string }>`
    position: absolute;
    background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;

const StyledAlienCode = styled.div<{ mainColor?: string }>`
    display: flex;
    align-items: center;
    column-gap: 10px;
    flex-direction: column;
    margin-bottom: 10px;
    .title {
        margin-bottom: 10px;
    }
    .alien-code-btn {
        color: #c4a363;
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 500;
        margin: 0;
        width: 100%;
        text-align: center;
        padding: 18px 0;
        background-color: #ddd;
        border-radius: 12px;
        background-image: url(../../images/bg-code.svg);
        background-size: cover;
    }
`;
const StyledContainerHistoryDetail = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;

    /* text-align: center; */
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    left: 50%;
    transform: translateX(-50%);
    animation: opacity 0.2s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .content {
        width: calc(100% - 30px);
        padding: 20px 0 20px 0;
        padding-bottom: 20px;
        background-color: ${(p) => p.theme.colors.card};
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 8px;
        max-height: 90%;
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .question-title {
            font-weight: 500;
            font-size: 20px;
            line-height: 27px;
            text-align: center;
            color: ${(p) => p.theme.colors.color};
        }
        .question-sub-title {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: ${(p) => p.theme.colors.color};
        }
    }
    .confirmation {
        line-height: 24px;
        color: ${(p) => p.theme.colors.color};
        padding: 0 20px 20px 20px;
        border-bottom: 1px solid rgba(115, 115, 115, 0.31);
    }
    .title {
        margin: 16px 0 0 0;
        line-height: 19px;
        color: #989898;
        padding: 0 20px 0 20px;
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        padding: 0 20px 0 20px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 20px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 16px;
        column-gap: 16px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .qr-layout {
        padding: 16px;
        display: flex;
        justify-content: center;
        position: relative;
        margin-bottom: 16px;
        .qr-box {
            padding: 24px;
            background: ${(p) => p.theme.colors.card};
            border-radius: 16px;
        }
        .code-btn {
        }
    }
    .confirm-btn {
        margin: 0;
    }
    .pdpa-name {
        line-height: 24px;
        color: ${(p) => p.theme.colors.color};
        padding: 0 20px 10px;
        text-align: center;
    }
    .pdpa-sub-title {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: ${(p) => p.themeColor};
    }
    .pdpa-condition {
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        padding: 0 20px;
    }
    .pdpa-content-layout {
        padding: 0 20px;
        margin: 20px 0;
    }
    .pdpa-container {
        /* background: ${(p) => p.theme.colors.card}; */
        background-color: #f4f6fa;
        /* border: 1px solid ${(p) => p.theme.colors.color}; */
        border-radius: 8px;
        max-height: 400px;
        p {
            font-size: 14px;
            line-height: 22px;
            color: ${(p) => p.theme.colors.color};
            text-align: left;
        }
        .scroll-layout {
            height: 300px;
            overflow: hidden;
            overflow-y: scroll;
            padding: 12px;
        }
        ul {
            li {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #000000;
            }
        }
        ol {
            li {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #000000;
            }
        }
    }
`;

const StyledPopupRedeem = styled.div<{ isConfirm: boolean }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: #336c51;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
    }
`;

const StyledContainerHistoryDetailDone = styled.div<{ isConfirm: boolean }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: #336c51;
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: #336c51;
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background-color: #336c51;
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .set-result {
            .layout-img {
                text-align: center;
                margin-top: -100px;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .header-product {
                margin-top: 0;
            }
            .fixed-layout {
                height: 70dvh;
                overflow: scroll;
            }
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: -100px;
            padding-bottom: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            margin-bottom: 50px;
            .topic-detail {
                text-align: center;
                color: #336c51;
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            padding: 10px;
        }
        .countdownBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .result-delivery {
                .title-delivery {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    text-align: center;
                    color: #9b9b9b;
                    margin-bottom: 15px;
                }
                .box-delivery {
                    background-color: #f7f7f7;
                    border-radius: 12px;
                    padding: 8px 16px;
                    text-align: center;
                    font-size: 12px;
                    line-height: 15px;
                    span {
                        font-size: 12px;
                        color: #336c51;
                        line-height: 15px;
                        margin-bottom: 10px;
                        display: block;
                        img {
                            margin-right: 5px;
                        }
                    }
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const StyledButton = styled(SharedButton)`
    width: 50%;
    margin: 26px auto 0 auto;
    padding: 0;
    height: 52px;
    border-radius: 26px;
    .decline-btn {
        background-color: pink !important;
    }
`;
const StyledStatusBtn = styled(SharedButton)`
    margin: 26px auto 0 auto;
    padding: 0;
    border-radius: 5px;
    height: 33px;
    font-size: 16px;
    width: 91px;
    font-weight: 200;
`;

const StyledButtonDecline = styled(StyledButton)`
    color: ${(p) => p.theme.colors.black} !important;
`;
